import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../lib/api";
import Header from "../components/Header";
import Footer from "../components/Footer";
import TopicCard from "../components/TopicCard";

export default function CategoryPage() {
    const { name } = useParams();
    const [topics, setTopics] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        api.get(`/topics?category=${encodeURIComponent(name)}&status=published`)
            .then((r) => setTopics(r.data || []))
            .catch(() => {})
            .finally(() => setLoading(false));
    }, [name]);

    return (
        <div className="min-h-screen bg-[#0B1220]">
            <Header />
            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-12 border-b border-[#243044]">
                <div className="text-[10px] uppercase tracking-[0.25em] text-[#56CCF2] font-medium mb-4">Category</div>
                <h1 className="text-4xl sm:text-5xl font-bold text-white tracking-tight mb-4" data-testid="category-title">
                    {decodeURIComponent(name)}
                </h1>
                <p className="text-sm text-[#94A3B8]">{topics.length} topic{topics.length === 1 ? "" : "s"}</p>
            </section>

            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                {loading ? (
                    <div className="text-center text-sm text-[#64748B] py-20">Loading…</div>
                ) : topics.length === 0 ? (
                    <div className="text-center py-20">
                        <p className="text-[#94A3B8]">No topics in this category yet.</p>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {topics.map((t) => (<TopicCard key={t.id || t.slug} topic={t} />))}
                    </div>
                )}
            </section>
            <Footer />
        </div>
    );
}
